import React from 'react';
import { AdvisoryPage } from './pages/AdvisoryPage';
export function App() {
  return <AdvisoryPage data-id="element-0" />;
}